<template>
  <div class="page-header">
    <div class="flex gap-2 align-center">
      <div v-if="back" class="cursor-pointer" @click="goRouter">
        <img src="@/assets/images/icons/back-icon.svg" alt="Attach Image">
      </div>
      <h3>{{ title }}</h3>
    </div>
    <div>
      <small>{{ breadcrumb }}</small>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    breadcrumb: String,
    back: Object || String || Number,
  },
  methods: {
    goRouter(){

        if(typeof this.back == "object" || typeof this.back == "string"){
          this.$router.push(this.back)
        }else if(typeof this.back == 'number'){
          this.$router.go(this.back)
        }
    }
  }
};
</script>

<style scoped>
.page-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
}
h3 {
  color: #10233e;
  font-size: 1.2rem;
  font-weight: 600;
}
small {
  color: #a5adb7;
}
</style>
